const sharpeningFeaturesZh = {
  // 台式磨削工作台（wb-001 ~ wb-010）
  product_wb_001_feature_1_title: '创新三合一多功能设计',
  product_wb_001_feature_1_desc: '标配随机轨道、轨道和细节砂光三种可更换底板，一台机器即可完美胜任大面积平整、边缘修整及狭小角落的精细研磨。',
  product_wb_001_feature_2_title: '多档调速与高效振荡',
  product_wb_001_feature_2_desc: '具备 7000-12000 rpm 的可调转速，配合高达 24000 rpm 的振荡频率，可根据木材、塑料或金属等不同材质精准匹配切削力。',
  product_wb_001_feature_3_title: '自主吸尘与清洁作业',
  product_wb_001_feature_3_desc: '内置自吸尘功能，并配备专业集尘盒与吸尘管适配器，能大幅减少作业现场粉尘，保护呼吸健康并保持工作面清晰。',
  product_wb_001_feature_4_title: '极致平衡的人体工学',
  product_wb_001_feature_4_desc: '1.3kg 的轻量化机身配合低重心平衡设计，结合顶部的软胶抓握区，有效降低操作震动，即使长时间进行高空或垂直面作业也毫无压力。',
  product_wb_001_feature_5_title: '全能配件包',
  product_wb_001_feature_5_desc: '随机附赠 3 种规格底板及配套的 6 张砂纸，真正的“开箱即用”，为您的木工创作与家居翻新提供全方位支持。',

  product_wb_002_feature_1_title: '全能型三合一磨削系统',
  product_wb_002_feature_1_desc: '配备三种专用磨削附件，可轻松修复钻头、凿子、刨刀以及各种家用刀具与剪刀，实现一机多用的极致便捷。',
  product_wb_002_feature_2_title: '精准的角度调节功能',
  product_wb_002_feature_2_desc: '特有角度可调附件，支持 6-51mm 宽度的凿子与刨刀进行精确对准磨削，确保每一次修复都能达到工业级的锋利精度。',
  product_wb_002_feature_3_title: '高速稳定与安全防护',
  product_wb_002_feature_3_desc: '6700/min 的稳定转速配合 Ø 51mm 专业磨轮，在保证高效切削的同时，II 类保护等级设计为您的操作提供全方位的安全保障。',
  product_wb_002_feature_4_title: '紧凑便携的工业设计',
  product_wb_002_feature_4_desc: '仅 1.3kg 的轻量化设计，机身紧凑（220*183*130mm），既不占用工作台空间，又方便随取随用，是家庭工作室的理想必备工具。',
  product_wb_002_feature_5_title: '120W 高效低速电机',
  product_wb_002_feature_5_desc: '120W 电机针对低速水磨优化，最小能耗实现最大磨刀效果。',

  product_wb_003_feature_1_title: '40,000 rpm 极致切削效能',
  product_wb_003_feature_1_desc: '提供 10,000 至 40,000/min 的超宽调速范围，即便在处理高硬度材质时也能确保雕刻与切割面丝滑平整。',
  product_wb_003_feature_2_title: '全能型 42 件专业附件包',
  product_wb_003_feature_2_desc: '随机附带 42 件套丰富附件，包含柔性轴、铣削定位罩及三脚架，一机轻松覆盖磨削、抛光、钻孔等全场景应用。',
  product_wb_003_feature_3_title: '大师级精准操控体验',
  product_wb_003_feature_3_desc: '仅 0.8kg 的轻巧身形结合内置 LED 工作灯与 3.2mm 精准夹头，让您在复杂狭小的空间内也能游刃有余地完成大师级创作。',
  product_wb_003_feature_4_title: '5.5 kg 防滑底座',
  product_wb_003_feature_4_desc: '5.5 kg 机身配防滑橡胶脚垫，激进粗磨操作时防止台面移动。',
  product_wb_003_feature_5_title: 'LED 工作灯',
  product_wb_003_feature_5_desc: '集成 LED 灯照亮磨削区域，磨刀时精准观察斜面角度。',

  product_wb_004_feature_1_title: '150 mm 软轴磨刀机组合',
  product_wb_004_feature_1_desc: '台式磨刀机配软轴附件，将磨削触达范围延伸至弯曲工具、雕刻品和不规则轮廓。',
  product_wb_004_feature_2_title: '软轴附件',
  product_wb_004_feature_2_desc: '软轴附件触达弯曲圆弧凿、雕刻刀和台式砂轮无法触及的不规则轮廓。',
  product_wb_004_feature_3_title: '200W 软轴动力传输',
  product_wb_004_feature_3_desc: '200W 电机通过软轴传输稳定动力，有效磨削复杂轮廓工具。',
  product_wb_004_feature_4_title: '5.8 kg 重载底座',
  product_wb_004_feature_4_desc: '5.8 kg 底座防止软轴在全伸展和角度使用时机器移动。',
  product_wb_004_feature_5_title: '可调软轴速度',
  product_wb_004_feature_5_desc: '软轴手柄上的速度控制，可针对不同的磨削、抛光和清洁附件调节工具速度。',

  product_wb_005_feature_1_title: '120W 稳定交流动力系统',
  product_wb_005_feature_1_desc: '采用 120W 高效交流电机，提供持续不掉速的动力输出，轻松胜任长时段的金属研磨与精细抛光任务。',
  product_wb_005_feature_2_title: '双功能磨抛轮与柔性软轴',
  product_wb_005_feature_2_desc: '标配 Ø75mm 砂轮（#120）与抛光轮（#400），实现从粗磨到镜面抛光的全流程覆盖，配合柔性软轴可进行高精度雕刻。',
  product_wb_005_feature_3_title: '11,500 rpm 高速调速性能',
  product_wb_005_feature_3_desc: '最高转速可达 11,500 rpm，配合精准的调速旋钮，可根据不同材质的硬度灵活切换最佳磨削速度。',
  product_wb_005_feature_4_title: '8.0 kg 工业级稳定性',
  product_wb_005_feature_4_desc: '8.0 kg 重型工业底座在高速 2900 RPM 磨削过程中消除所有振动和台面移动。',
  product_wb_005_feature_5_title: '200×25 mm 专业砂轮',
  product_wb_005_feature_5_desc: '宽 25 mm 砂轮面为在宽凿和刨刀上形成一致斜面提供更大的磨削表面。',

  product_wb_006_feature_1_title: '100 mm 紧凑台式磨刀机',
  product_wb_006_feature_1_desc: '100 mm 紧凑磨刀机占用最少台面空间，同时仍可磨削刀具、剪刀和小凿子。',
  product_wb_006_feature_2_title: '1450 RPM 标准速度',
  product_wb_006_feature_2_desc: '标准 1450 RPM 磨削速度安全地磨削小刀片和切削刃，不会过热薄钢。',
  product_wb_006_feature_3_title: '150W 紧凑电机',
  product_wb_006_feature_3_desc: '150W 紧凑电机刚好适合 100 mm 砂轮，高效磨削无过多能耗。',
  product_wb_006_feature_4_title: '4.0 kg 轻量台式工具',
  product_wb_006_feature_4_desc: '4.0 kg 是最轻的台式磨刀机，便携到可以收起来按需取用。',
  product_wb_006_feature_5_title: '节省空间 320 mm 体型',
  product_wb_006_feature_5_desc: '紧凑 320 mm 占地面积，在拥挤的工坊台面上与其他工具共存，不占主导位置。',

  product_wb_007_feature_1_title: '250 mm 工业落地磨刀机',
  product_wb_007_feature_1_desc: '250 mm 工业砂轮在落地立式底座上对大型工具、刀片和金属材料进行重型磨削。',
  product_wb_007_feature_2_title: '600W 最大工业动力',
  product_wb_007_feature_2_desc: '600W 电机在持续工业磨削和金属整形应用中驱动 250 mm 砂轮。',
  product_wb_007_feature_3_title: '15 kg 落地底座稳定性',
  product_wb_007_feature_3_desc: '15 kg 落地立式底座消除所有振动，提供重型磨削的工业级稳定性。',
  product_wb_007_feature_4_title: '1450 RPM 工业磨削',
  product_wb_007_feature_4_desc: '250 mm 砂轮上的 1450 RPM 工业速度，在所有工业应用中提供高效受控的磨削。',
  product_wb_007_feature_5_title: '5.0 N·m 最大扭矩',
  product_wb_007_feature_5_desc: '5.0 N·m 扭矩应对重型工具磨削时砂轮不减速，保持一致的去除率。',

  product_wb_008_feature_1_title: '150 mm 磨刀机配抛光砂轮',
  product_wb_008_feature_1_desc: '台式磨刀机配抛光砂轮附件，用抛光边缘完成磨刀流程。',
  product_wb_008_feature_2_title: '磨削 + 抛光组合装置',
  product_wb_008_feature_2_desc: '一机配备磨削砂轮和抛光砂轮，无需换工具即可完成完整磨刀和抛光流程。',
  product_wb_008_feature_3_title: '200W 双工位电机',
  product_wb_008_feature_3_desc: '200W 以 1450 RPM 驱动磨削和抛光两个工位，两个工序性能一致。',
  product_wb_008_feature_4_title: '5.5 kg 双工位稳定性',
  product_wb_008_feature_4_desc: '5.5 kg 机身重量在粗磨和抛光操作中都保持稳定的平台接触。',
  product_wb_008_feature_5_title: '75 dB 受控噪音',
  product_wb_008_feature_5_desc: '≤75 dB 受控噪音水平，适合噪音是考量因素的家庭工坊和车库使用。',

  product_wb_009_feature_1_title: '150 mm 变速磨刀机',
  product_wb_009_feature_1_desc: '变速 150 mm 台式磨刀机可调节砂轮转速，匹配钢铁硬度和斜面要求。',
  product_wb_009_feature_2_title: '1450 RPM 变速选项',
  product_wb_009_feature_2_desc: '从 50% 到全速 1450 RPM 的变速控制，允许对精细高碳钢刃进行精心磨削。',
  product_wb_009_feature_3_title: '200W 变速控制电机',
  product_wb_009_feature_3_desc: '200W 电机配电子速度控制，在任何设定速度水平都能提供一致的扭矩。',
  product_wb_009_feature_4_title: '5.2 kg 紧凑工坊磨刀机',
  product_wb_009_feature_4_desc: '5.2 kg 基准重量平衡便携性和稳定性，是多功能工坊磨刀工具。',
  product_wb_009_feature_5_title: '74 dB 低噪音特性',
  product_wb_009_feature_5_desc: '≤74 dB 是目前最低噪音的台式磨刀机之一，适合安静的工坊环境。',

  product_wb_010_feature_1_title: '300 mm 重型工业磨刀机',
  product_wb_010_feature_1_desc: '300 mm 专业磨刀机处理工业规模的工具磨削、焊缝研磨和重型金属处理。',
  product_wb_010_feature_2_title: '750W 最大工业电机',
  product_wb_010_feature_2_desc: '750W 电机是台式磨刀机系列最高功率，驱动 300 mm 砂轮穿过最硬的钢铁。',
  product_wb_010_feature_3_title: '20 kg 落地安装底座',
  product_wb_010_feature_3_desc: '20 kg 落地安装底座在重型工业磨削过程中消除所有移动，实现一致的专业效果。',
  product_wb_010_feature_4_title: '2900 RPM 最大磨削速度',
  product_wb_010_feature_4_desc: '最大砂轮上 2900 RPM 提供工业工具重新整形和重型处理的最大材料去除率。',
  product_wb_010_feature_5_title: '6.0 N·m 最大扭矩输出',
  product_wb_010_feature_5_desc: '6.0 N·m 最大扭矩输出即使在最重的工具磨削压力下也能保持砂轮速度。',

  // 钻头修复机（dr-001 ~ dr-010）
  product_dr_001_feature_1_title: '120W 持续交流动力输出',
  product_dr_001_feature_1_desc: '搭载 120W 高效交流电机，提供持续稳定的动力支持，确保在高负荷研磨或抛光作业中性能始终如一。',
  product_dr_001_feature_2_title: '多功能双轮与柔性软轴加工',
  product_dr_001_feature_2_desc: '配备 Ø75mm 砂轮与抛光轮组合，可同时处理粗磨与精抛工序；外接柔性软轴设计，轻松应对复杂形状的精细雕刻需求。',
  product_dr_001_feature_3_title: '11,500 rpm 高速变频调速',
  product_dr_001_feature_3_desc: '具备 0-11,500 rpm 的宽幅调速能力，用户可根据作业材质（金属、木材或珠宝）精准调节转速，实现最佳加工效果。',
  product_dr_001_feature_4_title: '150W 钻头电机',
  product_dr_001_feature_4_desc: '150W 电机恰好适合钻头磨削，高效精准，不过多施力。',
  product_dr_001_feature_5_title: '角度导向系统',
  product_dr_001_feature_5_desc: '内置角度导向每次确保正确的钻尖角度恢复，打孔性能一致。',

  product_dr_002_feature_1_title: '精准的高速研磨性能',
  product_dr_002_feature_1_desc: '搭载 95W 高效电机，提供 1350 rpm 的稳定转速，确保钻头切削刃研磨精准、锋利如新。',
  product_dr_002_feature_2_title: '广泛的钻头尺寸适配',
  product_dr_002_feature_2_desc: '专门针对常用规格设计，可研磨直径范围为 3-12mm (1/8"-15/32") 的多种标准钻头。',
  product_dr_002_feature_3_title: '轻量化紧凑设计',
  product_dr_002_feature_3_desc: '整机重量仅 0.95kg，外形紧凑（210100180mm），极易携带且不占工作台空间，适合各种作业场景。',
  product_dr_002_feature_4_title: '4.5 kg 稳固重载底座',
  product_dr_002_feature_4_desc: '4.5 kg 机身在用力手压磨削大型重型钻头时防止磨刀机移动。',
  product_dr_002_feature_5_title: '精密夹头导向系统',
  product_dr_002_feature_5_desc: '精密夹头将钻头导引到精确的磨削角度，实现可重复的出厂质量效果。',

  product_dr_003_feature_1_title: '精准的高速研磨性能',
  product_dr_003_feature_1_desc: '搭载 95W 高效电机，提供 1350 rpm 的稳定转速，确保钻头切削刃研磨精准、锋利如新。',
  product_dr_003_feature_2_title: '广泛的钻头尺寸适配',
  product_dr_003_feature_2_desc: '专门针对常用规格设计，可研磨直径范围为 3-12mm (1/8"-15/32") 的多种标准钻头。',
  product_dr_003_feature_3_title: '轻量化紧凑设计',
  product_dr_003_feature_3_desc: '整机重量仅 0.95kg，外形紧凑（210100180mm），极易携带且不占工作台空间，适合各种作业场景。',
  product_dr_003_feature_4_title: '2.0 kg 最轻钻头磨刀机',
  product_dr_003_feature_4_desc: '仅 2.0 kg，这是最便携的钻头磨刀机，可装入任何工具箱随时现场重新磨削。',
  product_dr_003_feature_5_title: '简单一步导向',
  product_dr_003_feature_5_desc: '单步导向系统使磨削快速简便，插入钻头、按下，恢复出厂锋利度。',

  product_dr_004_feature_1_title: '更广的钻头适配范围',
  product_dr_004_feature_1_desc: '支持 Ф3-13mm (1/8-1/2”) 范围内的钻头研磨，相比其他型号拥有更大的兼容性。',
  product_dr_004_feature_2_title: '高效稳定的电机性能',
  product_dr_004_feature_2_desc: '搭载 95W 电机，转速恒定在1350rpm，确保研磨过程平稳且切削刃均匀。',
  product_dr_004_feature_3_title: '紧凑且易于操作',
  product_dr_004_feature_3_desc: '垂直紧凑设计且重量仅1kg，配合精准的定位孔，即使是非专业人士也能快速上手',
  product_dr_004_feature_4_title: '4.0 kg 均衡工坊工具',
  product_dr_004_feature_4_desc: '4.0 kg 提供工坊级稳定性，在整个钻头尺寸范围内实现精准一致的磨削。',
  product_dr_004_feature_5_title: '多角度导向位置',
  product_dr_004_feature_5_desc: '多种导向角度位置，兼容标准和专业钻头类型不同的钻尖几何形状。',

  product_dr_005_feature_1_title: '3–16 mm 工业磨刀机',
  product_dr_005_feature_1_desc: '扩展 3–16 mm 范围覆盖大型工业钻头，包括金属加工中使用的岩芯钻头和环形钻头。',
  product_dr_005_feature_2_title: '200 mm 大型工业砂轮',
  product_dr_005_feature_2_desc: '200 mm 砂轮提供最大磨削面积，快速磨削大型 16 mm 和专业工业钻头。',
  product_dr_005_feature_3_title: '250W 工业电机',
  product_dr_005_feature_3_desc: '250W 工业电机驱动 200 mm 砂轮，在生产环境中实现高吞吐量的钻头维护。',
  product_dr_005_feature_4_title: '6.0 kg 工业稳定底座',
  product_dr_005_feature_4_desc: '6.0 kg 重型底座在用力施压大径钻头磨削时防止移动。',
  product_dr_005_feature_5_title: '工业夹头导向套组',
  product_dr_005_feature_5_desc: '完整夹头导向套组覆盖 3 mm 到 16 mm 所有钻头尺寸，任何类型精准角度恢复。',

  product_dr_006_feature_1_title: '3–13 mm 专业工坊磨刀机',
  product_dr_006_feature_1_desc: '扩展 5.0 kg 底座的专业工坊磨刀机，精准稳定地磨削 3–13 mm 钻头。',
  product_dr_006_feature_2_title: '200W 延伸循环电机',
  product_dr_006_feature_2_desc: '200W 电机支持繁忙工坊中连续磨削循环，不会导致电机热过载。',
  product_dr_006_feature_3_title: '5.0 kg 专业稳定平台',
  product_dr_006_feature_3_desc: '5.0 kg 平台在 150 mm 范围内提供最稳定的底座，实现专业级磨削精度。',
  product_dr_006_feature_4_title: '精密钻尖角度系统',
  product_dr_006_feature_4_desc: '精密角度系统恢复精确的出厂钻尖几何形状，实现最佳切削性能。',
  product_dr_006_feature_5_title: '3000 RPM 一致磨削',
  product_dr_006_feature_5_desc: '3000 RPM 一致速度去除恢复锋利度所需的最少金属，延长钻头使用寿命。',

  product_dr_007_feature_1_title: '3–13 mm 高速磨刀机',
  product_dr_007_feature_1_desc: '高速 4500 RPM 磨刀机减少每个钻头所需时间，适合钻头吞吐量大的繁忙工坊。',
  product_dr_007_feature_2_title: '4500 RPM 极速磨削',
  product_dr_007_feature_2_desc: '4500 RPM 是标准 3000 RPM 型号磨削速度的两倍，非常适合需要快速翻转的繁忙工坊。',
  product_dr_007_feature_3_title: '250W 高速电机',
  product_dr_007_feature_3_desc: '250W 电机在高速 4500 RPM 磨削操作中持续更高的能耗需求而不过热。',
  product_dr_007_feature_4_title: '4.8 kg 高速稳定性',
  product_dr_007_feature_4_desc: '4.8 kg 底座吸收高速磨削的振动，在 4500 RPM 下保持精度。',
  product_dr_007_feature_5_title: '快速散热系统',
  product_dr_007_feature_5_desc: '增强的气冷防止高速磨削时热量传递到钻头，保护钻头的回火硬度。',

  product_dr_008_feature_1_title: '3–16 mm 重型磨刀机',
  product_dr_008_feature_1_desc: '重型 300W 机器，处理从精密小钻头到大型 16 mm 工业钻头的全范围。',
  product_dr_008_feature_2_title: '300W 最大磨削动力',
  product_dr_008_feature_2_desc: '300W 提供快速高效磨削需要大量金属去除的大型工业钻头所需的动力。',
  product_dr_008_feature_3_title: '200 mm 重型砂轮',
  product_dr_008_feature_3_desc: '200 mm 砂轮为大径钻头提供最大磨削表面，减少所需的通过次数。',
  product_dr_008_feature_4_title: '8.0 kg 最大稳定性',
  product_dr_008_feature_4_desc: '8.0 kg 提供系列中最大的稳定性，精确磨削大型重型钻头至关重要。',
  product_dr_008_feature_5_title: '工业夹头夹紧系统',
  product_dr_008_feature_5_desc: '重型夹头系统牢固固定大径钻头，实现精准无振动的高功率磨削。',

  product_dr_009_feature_1_title: '0.5–6 mm 精密迷你磨刀机',
  product_dr_009_feature_1_desc: '精密 0.5–6 mm 磨刀机，适用于微型 PCB 钻头、钟表钻头和精密工程微型钻头。',
  product_dr_009_feature_2_title: '80 mm 微型磨削砂轮',
  product_dr_009_feature_2_desc: '80 mm 微型砂轮针对最细钻头精确缩放，不损坏地精准磨削。',
  product_dr_009_feature_3_title: '80W 精密微型电机',
  product_dr_009_feature_3_desc: '80W 精密电机以精确的速度运行 80 mm 砂轮，实现精细微型钻头磨削。',
  product_dr_009_feature_4_title: '1.5 kg 便携式精密工具',
  product_dr_009_feature_4_desc: '1.5 kg 便携机身可在台面任何位置使用，微型钻头磨削无需固定安装。',
  product_dr_009_feature_5_title: '放大观察窗',
  product_dr_009_feature_5_desc: '放大观察窗允许微型钻头磨削前后的精准视觉对准。',

  product_dr_010_feature_1_title: '3–20 mm 最大范围磨刀机',
  product_dr_010_feature_1_desc: '涵盖 3–20 mm 最宽范围的磨刀机，从精细工坊钻头到大型结构岩芯钻头全部覆盖。',
  product_dr_010_feature_2_title: '400W 最大动力磨刀机',
  product_dr_010_feature_2_desc: '400W 最大磨削动力，高效磨削范围内从精细 3 mm 到重型 20 mm 工业钻头的所有尺寸。',
  product_dr_010_feature_3_title: '250 mm 专业级砂轮',
  product_dr_010_feature_3_desc: '系列中最大的 250 mm 砂轮提供最大表面积，全面工业钻头磨削。',
  product_dr_010_feature_4_title: '12 kg 落地安装稳定性',
  product_dr_010_feature_4_desc: '12 kg 落地安装底座在高压磨削大型 20 mm 工业钻头时消除所有移动。',
  product_dr_010_feature_5_title: '全范围夹头导向套组',
  product_dr_010_feature_5_desc: '随附从 3 mm 到 20 mm 每种钻头尺寸的完整夹头导向套组，无需额外购买。',

  // 雕刻工具（eg-001 ~ eg-010）
  product_eg_001_feature_1_title: '无绳束缚，Type-C 灵活充电',
  product_eg_001_feature_1_desc: '采用 4V 锂电驱动配合通用 Type-C 接口，摆脱电源线束缚，随时随地开启刻写创作。',
  product_eg_001_feature_2_title: '6档调速，精准掌握频率',
  product_eg_001_feature_2_desc: '具备 6000 至 19000/min 的宽幅调速区间，6 档频率可调，确保在不同硬度材料上都能实现精准控制。',
  product_eg_001_feature_3_title: '紧凑机身与全能交互',
  product_eg_001_feature_3_desc: '仅 0.25kg 的超轻机身，配备内置 LED 工作灯与电量指示灯，即便在光线不足环境下也能精准作业。',
  product_eg_001_feature_4_title: '0.6 kg 单手雕刻',
  product_eg_001_feature_4_desc: '仅 0.6 kg，这款工具轻便到可单手精确雕刻、刻字和小物品细节施工。',
  product_eg_001_feature_5_title: 'CE/RoHS 安全认证',
  product_eg_001_feature_5_desc: 'CE 和 RoHS 认证，符合欧洲安全和环境标准的工坊和家庭使用安全认可。',

  product_eg_002_feature_1_title: '笔式设计，精准操控',
  product_eg_002_feature_1_desc: '仅 0.33kg 的超轻量化设计，配合人体工学笔式握法，提供极其自然的操控感，适合长时间精细刻字作业。',
  product_eg_002_feature_2_title: '高速冲击，清晰刻印',
  product_eg_002_feature_2_desc: '具备每分钟 6000 次的高频冲程，能在金属、玻璃、木材及塑料等多种材质上留下清晰、永久的痕迹。',
  product_eg_002_feature_3_title: '全能模板附件组',
  product_eg_002_feature_3_desc: '标配数字、字母及符号多种刻字模板，确保新手也能刻划出整齐、美观的专业级文字。',
  product_eg_002_feature_4_title: '0.7 kg 均衡刻字重量',
  product_eg_002_feature_4_desc: '0.7 kg 均衡重量，减少在金属板和珠宝上进行长时间刻字作业时的腕部疲劳。',
  product_eg_002_feature_5_title: '70 dB 低噪旋转',
  product_eg_002_feature_5_desc: '≤70 dB 静音操作，适合在详细艺术施工中必须最小化噪音的工作室环境。',

  product_eg_003_feature_1_title: '80W 高功率雕刻工具',
  product_eg_003_feature_1_desc: '80W 高功率旋转工具处理更硬的材料，包括硬木雕刻、金属刻字和石材细节。',
  product_eg_003_feature_2_title: '80W 最大雕刻动力',
  product_eg_003_feature_2_desc: '80W 是最高单功率旋转工具，提供激进硬木和金属雕刻所需的扭矩。',
  product_eg_003_feature_3_title: '变速 + 正反转',
  product_eg_003_feature_3_desc: '正反转结合变速，扩展了可能的雕刻和收尾技术范围。',
  product_eg_003_feature_4_title: '5000–25000 RPM 全范围',
  product_eg_003_feature_4_desc: '单一强大工具涵盖从慢速精密施工到最高速切割和刻字的完整速度范围。',
  product_eg_003_feature_5_title: '0.25 N·m 高扭矩',
  product_eg_003_feature_5_desc: '0.25 N·m 扭矩使高功率 80W 工具在艰难的硬木和金属施工中遇到阻力时保持速度。',

  product_eg_004_feature_1_title: '65W 20V 无绳雕刻工具',
  product_eg_004_feature_1_desc: '20V 电池供电旋转工具，在任何地方雕刻、刻字和磨削，无需电源插座。',
  product_eg_004_feature_2_title: '20V 无绳电池平台',
  product_eg_004_feature_2_desc: '20V 电池与其他工具共享，无需为雕刻和刻字设置单独的充电器。',
  product_eg_004_feature_3_title: '5000–25000 RPM 无绳速度',
  product_eg_004_feature_3_desc: '电池动力可用全变速范围，不受电源线限制的完整雕刻和刻字自由。',
  product_eg_004_feature_4_title: '0.7 kg 无绳雕刻重量',
  product_eg_004_feature_4_desc: '含电池 0.7 kg，保持工具单手精密雕刻和刻字的舒适感。',
  product_eg_004_feature_5_title: '户外随处刻字',
  product_eg_004_feature_5_desc: '无绳 20V 设计使户外石材刻字、庭院雕塑和现场艺术创作不需要电源接入。',

  product_eg_005_feature_1_title: '80W 高速刻字工具',
  product_eg_005_feature_1_desc: '80W 最高 30000 RPM，在金属板、玻璃蚀刻和精细细节施工中实现高频刻字。',
  product_eg_005_feature_2_title: '10000–30000 RPM 高速范围',
  product_eg_005_feature_2_desc: '高达 30000 RPM 的扩展高速范围，实现用于玻璃蚀刻和石材雕刻的精细金刚石钻头刻字应用。',
  product_eg_005_feature_3_title: '金刚石钻头兼容性',
  product_eg_005_feature_3_desc: '高速范围针对玻璃蚀刻、石材雕刻和珠宝施工中使用的金刚石刻字钻头优化。',
  product_eg_005_feature_4_title: '55°C 热保护',
  product_eg_005_feature_4_desc: '热传感器在超过 55°C 时关闭工具，保护电机和精细工件免受热损伤。',
  product_eg_005_feature_5_title: '80W 速度恢复电机',
  product_eg_005_feature_5_desc: '80W 电机在刻字钻头遇到材料阻力时瞬间恢复设定速度，实现一致的线质量。',

  product_eg_006_feature_1_title: '50W 精密微型刻字机',
  product_eg_006_feature_1_desc: '50W 精密刻字机配 2.35 mm 夹头，适用于最小刻字钻头和最精细的细节施工。',
  product_eg_006_feature_2_title: '2.35 mm 精细夹头尺寸',
  product_eg_006_feature_2_desc: '2.35 mm 较小夹头尺寸，兼容用于复杂珠宝、钟表和电路板施工的超精细刻字钻头。',
  product_eg_006_feature_3_title: '0.5 kg 最轻雕刻工具',
  product_eg_006_feature_3_desc: '0.5 kg 是系列中最轻的旋转工具，精美艺术品的最小重量实现最大控制。',
  product_eg_006_feature_4_title: '50W 精细动力电机',
  product_eg_006_feature_4_desc: '50W 较低功率电机专为精细精密刻字设计，最小工具运动至关重要。',
  product_eg_006_feature_5_title: '68 dB 超静音工作室',
  product_eg_006_feature_5_desc: '≤68 dB 是系列中最安静的旋转工具，非常适合安静工作室环境和珠宝工坊。',

  product_eg_007_feature_1_title: '80W 双速雕刻工具',
  product_eg_007_feature_1_desc: '80W 双速旋转工具在定义的低速和高速预设之间切换，快速交替任务。',
  product_eg_007_feature_2_title: '5000–30000 RPM 最宽范围',
  product_eg_007_feature_2_desc: '从 5000 到 30000 RPM 的最宽速度范围，一台工具覆盖所有雕刻、磨削和刻字应用。',
  product_eg_007_feature_3_title: '双速预设切换',
  product_eg_007_feature_3_desc: '快速访问双速切换按键，在预设慢速和快速之间切换，无需查看转盘。',
  product_eg_007_feature_4_title: '0.8 kg 延伸控制机身',
  product_eg_007_feature_4_desc: '0.8 kg 延伸机身改善大型木雕和面板持续雕刻作业的杠杆力。',
  product_eg_007_feature_5_title: '延伸 212 mm 控制长度',
  product_eg_007_feature_5_desc: '212 mm 较长机身，在笔直雕刻线和一致深度刻字时提供更好的双手控制。',

  product_eg_008_feature_1_title: '65W 大型 6 mm 夹头铣削机',
  product_eg_008_feature_1_desc: '65W 旋转工具配大型 6 mm 夹头，接受更大的铣削钻头，用于木工细节铣削和嵌入切割。',
  product_eg_008_feature_2_title: '6 mm 大夹头铣削能力',
  product_eg_008_feature_2_desc: '6 mm 夹头兼容更大、更激进的铣削钻头，用于木工细节铣削、嵌入和边缘施工。',
  product_eg_008_feature_3_title: '5000–25000 RPM 铣削速度',
  product_eg_008_feature_3_desc: '针对 6 mm 铣削和雕刻钻头范围优化的变速，控制用慢速，整洁去料用快速。',
  product_eg_008_feature_4_title: '0.22 N·m 铣削扭矩',
  product_eg_008_feature_4_desc: '0.22 N·m 扭矩在 6 mm 钻头接触致密硬木纹理时保持铣削速度。',
  product_eg_008_feature_5_title: '205 mm 精密铣削长度',
  product_eg_008_feature_5_desc: '205 mm 机身提供使用靠山或模板附件进行引导直线铣削所需的控制。',

  product_eg_009_feature_1_title: '80W 往复雕刻工具',
  product_eg_009_feature_1_desc: '80W 往复动作在木材、石材和硬化材料上实现受控锤凿雕刻。',
  product_eg_009_feature_2_title: '3000–8000 SPM 雕刻速度',
  product_eg_009_feature_2_desc: '3000–8000 SPM 往复速度为精准石雕和木质浮雕施工提供所需的控制。',
  product_eg_009_feature_3_title: '往复凿刀动作',
  product_eg_009_feature_3_desc: '往复动作模拟木凿，在石材、硬木和复合材料上实现受控材料去除。',
  product_eg_009_feature_4_title: '0.25 N·m 冲击雕刻扭矩',
  product_eg_009_feature_4_desc: '往复模式中 0.25 N·m 扭矩为石材刻字和硬木浮雕提供有效的凿切力。',
  product_eg_009_feature_5_title: '68 dB 静音凿刀雕刻',
  product_eg_009_feature_5_desc: '≤68 dB 静音操作使这款往复雕刻机适合工作室和住宅工坊环境。',

  product_eg_010_feature_1_title: '80W 专业雕刻系统',
  product_eg_010_feature_1_desc: '80W 专业旋转雕刻系统，为艺术家、工匠和修复师配备全面配件套组。',
  product_eg_010_feature_2_title: '5000–25000 RPM 专业范围',
  product_eg_010_feature_2_desc: '5000–25000 RPM 全专业速度范围覆盖所有雕刻、磨削、切割和抛光应用。',
  product_eg_010_feature_3_title: '专业配件套组',
  product_eg_010_feature_3_desc: '随附全面的专业配件套组，包括雕刻钻头、砂石、切割片和抛光盘。',
  product_eg_010_feature_4_title: '215 mm 专业控制长度',
  product_eg_010_feature_4_desc: '215 mm 延伸机身提供持续专业雕刻作业所需的双手控制。',
  product_eg_010_feature_5_title: '12 个月专业质保',
  product_eg_010_feature_5_desc: '12 个月质保配 CE 和 RoHS 认证，支持每日工作室使用中的专业艺术家和工匠。',

  // ===== 磨削工具配件翻译 (sp_acc_* 系列) =====

  // 工作台磨削配件
  sp_acc_diamond_wheels_name: '金刚石砂轮套装',
  sp_acc_diamond_wheels_desc: '粗中细三种目数金刚石磨削砂轮，满足从粗磨到精磨的全流程需求',
  sp_acc_angle_guide_name: '精密角度导轨',
  sp_acc_angle_guide_desc: '15°~45°可调精密角度导轨夹具，确保每次磨削角度一致准确',
  sp_acc_honing_compound_name: '研磨抛光膏',
  sp_acc_honing_compound_desc: '专业氧化铝研磨膏，去除细划痕、恢复刃口锋利度和镜面光洁',
  sp_acc_blade_clamp_name: '万用刀片夹具',
  sp_acc_blade_clamp_desc: '可调宽度不锈钢刀片夹具，稳固固定各类刀具，确保磨削精度',
  sp_acc_dressing_tool_name: '砂轮修整器',
  sp_acc_dressing_tool_desc: '金刚石刀头星轮修整器，恢复砂轮平整度和磨削效率',
  sp_acc_work_mat_name: '防滑工作台垫',
  sp_acc_work_mat_desc: '防滑橡胶台垫，减震吸振，防止磨削台面移位',
  sp_acc_angle_gauge_name: '数显角度计',
  sp_acc_angle_gauge_desc: 'LCD显示磁座数显角度计，精确测量刀片研磨角度',
  sp_acc_sharpening_manual_name: '研磨参考手册',
  sp_acc_sharpening_manual_desc: '各类工具推荐磨削角度参考手册，快速查询最优参数',
  sp_acc_whetstone_set_name: '水冷磨刀石',
  sp_acc_whetstone_set_desc: '天然水冷矩形磨刀石，防止热变形，保留钢材回火硬度',
  sp_acc_water_trough_name: '水冷槽',
  sp_acc_water_trough_desc: '湿式磨刀机专用储水槽，持续冷却砂轮，防止刀刃过热',
  sp_acc_leather_strop_name: '皮革磨刀轮',
  sp_acc_leather_strop_desc: '真皮磨刀轮，研磨后用于精修刃口，实现剃刀级锋利度',
  sp_acc_digital_caliper_name: '数显游标卡尺',
  sp_acc_digital_caliper_desc: 'LCD显示150mm不锈钢数显卡尺，用于精确测量刀刃和磨削参数',
  sp_acc_carry_case_name: '便携收纳箱',
  sp_acc_carry_case_desc: '硬壳泡沫内衬收纳箱，安全存储和携带工具及配件',
  sp_acc_grinding_oil_name: '磨削润滑油',
  sp_acc_grinding_oil_desc: '500ml金属磨削切削润滑油，防腐防锈，延长砂轮寿命',
  sp_acc_heavy_clamp_name: '重型台钳',
  sp_acc_heavy_clamp_desc: '铸铁重型台钳，工业级稳固夹持，适合大型工具磨削作业',
  sp_acc_smart_sensor_name: '智能角度传感器',
  sp_acc_smart_sensor_desc: '数字角度探针传感器，自动识别刀具几何形状，辅助精准研磨',

  // 钻头修复机配件
  sp_acc_grinding_wheel_dr_name: '替换磨削砂轮',
  sp_acc_grinding_wheel_dr_desc: '80目氧化铝磨料砂轮，专为钻头研磨机设计，高效修复钻尖',
  sp_acc_collet_set_name: '夹头套装',
  sp_acc_collet_set_desc: '3/6/8/10/13mm多规格精密夹头套装，兼容各种直径钻头',
  sp_acc_drill_bit_set_name: '麻花钻头套装',
  sp_acc_drill_bit_set_desc: 'HSS高速钢麻花钻头套装，1~13mm多种规格，附收纳盒',
  sp_acc_cleaning_brush_name: '清洁刷套装',
  sp_acc_cleaning_brush_desc: '金属刷+尼龙软刷清洁套装，清除磨削碎屑，维护设备清洁',
  sp_acc_cutting_oil_name: '切削润滑油',
  sp_acc_cutting_oil_desc: '300ml金属切削液，钻头磨削专用，润滑降温防锈',
  sp_acc_drill_holder_name: '钻头收纳架',
  sp_acc_drill_holder_desc: '金属钻头收纳支架，多尺寸分档存放，整理有序取用方便',
  sp_acc_safety_goggles_name: '防护目镜',
  sp_acc_safety_goggles_desc: '透明镜片防护目镜，防磨削碎屑飞溅，保护眼睛安全',
  sp_acc_guide_rail_name: '精密导向架',
  sp_acc_guide_rail_desc: '台式精密导向定位架，确保钻头以精确角度进入磨削区域',
  sp_acc_step_bit_set_name: '阶梯钻头套装',
  sp_acc_step_bit_set_desc: '钛涂层HSS阶梯锥形钻头套装，4~32mm范围，多用途',
  sp_acc_auto_feed_belt_name: '自动送料皮带',
  sp_acc_auto_feed_belt_desc: '橡胶驱动皮带，自动送料机专用，定期更换确保稳定送料',
  sp_acc_diamond_wheel_fine_name: '细粒金刚石砂轮',
  sp_acc_diamond_wheel_fine_desc: '120目细粒金刚石砂轮，高速兼容，实现钻尖精细精磨',
  sp_acc_cnc_probe_name: 'CNC探针',
  sp_acc_cnc_probe_desc: '数控触摸探针，精确校准，确保CNC钻头磨削程序的位置精度',
  sp_acc_micro_grinding_wheel_name: '微型精密砂轮',
  sp_acc_micro_grinding_wheel_desc: '600目细粒微型砂轮，专为小径钻头研磨机设计，超精密磨削',
  sp_acc_micro_collet_set_name: '微型夹头套装',
  sp_acc_micro_collet_set_desc: '0.5/1/1.5/2/3mm微型夹头套装，适用于精密小径钻头固定',
  sp_acc_micro_drill_set_name: '微型钻头套装',
  sp_acc_micro_drill_set_desc: 'PCB珠宝手表用0.5~3mm HSS微型钻头套装，附专用收纳盒',
  sp_acc_magnifier_loupe_name: '放大镜',
  sp_acc_magnifier_loupe_desc: '10倍宝石商放大镜，精密检查微型钻尖对准情况',

  // 雕刻工具配件
  sp_acc_engraving_bit_set_name: '雕刻刀头套装',
  sp_acc_engraving_bit_set_desc: '50件钨钢旋转磨头套装，球形/锥形/圆柱形等多种形状，全面覆盖各类雕刻需求',
  sp_acc_collet_set_eg_name: '雕刻机夹头套装',
  sp_acc_collet_set_eg_desc: '1/2/3/3.17mm多规格雕刻工具专用夹头套装，快速切换',
  sp_acc_flexible_shaft_name: '软轴延伸附件',
  sp_acc_flexible_shaft_desc: '1米柔性传动软轴，延伸雕刻工具触达范围，灵活转向作业',
  sp_acc_work_stand_name: '工具悬挂支架',
  sp_acc_work_stand_desc: '可调节金属悬挂支架，闲置时竖直放置雕刻工具，防止滑动',
  sp_acc_polishing_compound_name: '金属抛光膏',
  sp_acc_polishing_compound_desc: '白/绿/红色抛光膏套装，多阶段金属表面精抛，实现镜面效果',
  sp_acc_dust_collector_name: '集尘防护罩',
  sp_acc_dust_collector_desc: '透明塑料集尘防护罩，收集雕刻碎屑，保持工作台整洁',
  sp_acc_storage_case_eg_name: '工具收纳盒',
  sp_acc_storage_case_eg_desc: '泡沫内衬拉链收纳盒，整齐存放雕刻工具及所有配件',
  sp_acc_lithium_battery_eg_name: '锂电池',
  sp_acc_lithium_battery_eg_desc: '20V 2Ah可充电锂电池，为无绳雕刻工具提供持续电力',
  sp_acc_charger_eg_name: '充电器',
  sp_acc_charger_eg_desc: '20V锂电池快充充电器，LED状态指示，高效安全充电',
  sp_acc_wood_carving_bits_name: '木雕专用刀头',
  sp_acc_wood_carving_bits_desc: 'HSS高速钢木雕旋转刀头套装，球形/火焰形/圆柱形，专为木材纹理优化',
  sp_acc_metal_engraving_bits_name: '金属雕刻刀头',
  sp_acc_metal_engraving_bits_desc: '硬质合金金刚石涂层金属雕刻刀头，适用于钢铝铜等金属表面刻字装饰',
  sp_acc_micro_bit_set_eg_name: '微型雕刻刀头套装',
  sp_acc_micro_bit_set_eg_desc: '珠宝钟表专用0.5/1mm金刚石微型雕刻刀头，超精细细节作业',
  sp_acc_micro_collet_eg_name: '微型夹头',
  sp_acc_micro_collet_eg_desc: '0.5~1.5mm精密微型夹头，适用于超精细雕刻作业',
};

export default sharpeningFeaturesZh;
